<template>
  <div id="projectMemberManage" v-if="divVisible">
    <b>プロジェクト要員情報管理画面</b><br/><br/>

    <table>
      <tr>
        <td>プロジェクト要員情報を管理いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader0" class="table table-striped">
          <tbody>
            <tr>
              <td><b>プロジェクト名：</b></td>
              <td>{{ rows[0].projectInfo.projectName }}</td>
            </tr>
            <tr>
              <td><b>プロジェクト期間：</b></td>
              <td>{{ rows[0].projectInfo.startDate + " ～ " +  rows[0].projectInfo.endDate }}</td>
            </tr>
          </tbody>
        </table><br/>

        <table id="rptHeader1" class="table table-striped">
          <tbody>
            <tr>
              <td><b>参加要員：</b></td>
              <td>
                <select
                  v-bind:disabled="rows[0].operationType == 'delete'"
                  v-model="rows[0].projectMemberInfos[0].memberID"
                  @change="onRowMemberInfoSelected($event)">
                  <option value="" />
                  <option
                    v-for="(rowMemberInfo, index3) in rows[0].memberInfos"
                    v-bind:key="'rowMemberInfo' + index3"
                    v-bind:value="rowMemberInfo.memberID"
                    v-text="rowMemberInfo.memberID + ':' + rowMemberInfo.memberName" />
                </select><br/>
              </td>
            </tr>
            <tr>
              <td><b>参加役割：</b></td>
              <td>
                <label v-for="(rowOptionJoinMemberType, index3) in rows[0].optionJoinMemberTypes" v-bind:key="'rowOptionJoinMemberType' + index3">
                  <input type="radio"
                    v-bind:disabled="rows[0].operationType == 'delete'"
                    v-model="rows[0].projectMemberInfos[0].joinMemberType"
                    v-bind:value="rowOptionJoinMemberType.value"
                    @change="onOptionJoinMemberTypeClick($event)">{{ rowOptionJoinMemberType.text }}&nbsp;&nbsp;
                </label>
              </td>
            </tr>
            <tr v-for="(rowProjectMemberInfo, index4) in rows[0].projectMemberInfos" v-bind:key="'rowProjectMemberInfo' + index4">
              <td><b>参加期間：</b></td>
              <td>
                <input type="month" v-bind:disabled="rows[0].operationType == 'delete'" v-model="rowProjectMemberInfo.joinStartDate">
                &nbsp;～&nbsp;
                <input type="month" v-bind:disabled="rows[0].operationType == 'delete'" v-model="rowProjectMemberInfo.joinEndDate">
              </td>
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="rows[0].operationType == 'delete'">削除</button>&nbsp;
      <button v-on:click="processClick" class="btn-mid" style="width:250px;" v-if="rows[0].operationType == 'create'">新規</button>&nbsp;
      <button @click="$router.back(-1);" class="btn-mid" style="width:250px;">キャンセル</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "projectMemberManage",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          // heads: [ ],
          rows:  [ { operationType: '',
                     projectInfo: { projectID: '', projectName: '', startDate: '', endDate: '' },
                     memberInfos: [ { memberID: '', memberName: '', userType: '' }, ],
                     projectMemberInfos: [ { projectID: '', memberID: '', joinStartDate: '', joinEndDate: '', joinMemberType: '' }, ],
                     optionJoinMemberTypes: [ { value: '', text: '' }, ] },
                 ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/ProjectMemberManageInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                // self.heads = res.data.heads;
                self.rows = res.data.rows;
                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });
      },
      processClick: function () {
        var self = this;
        var data = { rowData:JSON.stringify(self.rows[0]) };
        common.getAxios().post(process.env.API_URL +"/api/ProjectMemberManageProcess", data)
          .then(function (res) {
            // 処理正常の場合
            if (res.data == '') {
              self.$router.push({ name: 'projectDetails',
                params: { backScreenId: self.$route.params.backScreenId, year: self.$route.params.year, projectID: self.rows[0].projectInfo.projectID } });
            }
            // 処理エラーの場合
            else {
              alert(res.data);
            }
          })
          .catch(function (err) {
            alert(err);
          });
      },
      onRowMemberInfoSelected: function (event) {
        // this.rows[0].projectMemberInfos[0].memberID = this.rows[0].projectMemberInfos[0].memberID;
        this.rows[0].projectMemberInfos[1].memberID = this.rows[0].projectMemberInfos[0].memberID;
        this.rows[0].projectMemberInfos[2].memberID = this.rows[0].projectMemberInfos[0].memberID;
      },
      onOptionJoinMemberTypeClick: function (event) {
        // this.rows[0].projectMemberInfos[0].joinMemberType = this.rows[0].projectMemberInfos[0].joinMemberType;
        this.rows[0].projectMemberInfos[1].joinMemberType = this.rows[0].projectMemberInfos[0].joinMemberType;
        this.rows[0].projectMemberInfos[2].joinMemberType = this.rows[0].projectMemberInfos[0].joinMemberType;
      },

    }
  };
</script>



// WEBPACK FOOTER //
// projectMemberManage.vue?5956cf95